import { createAction, props } from '@ngrx/store';
import { CollectionAttributes, AdvisorResponse, SourceDocument } from 'src/app/models/advisor.interface';
import { ChatMessage } from 'src/app/models/conversations.interface';

// Conversations
export const saveSession = createAction(
  '[Session] Save Session',
  props<{ session_id: string; collection_id: string; collection_name: string }>()
);
export const loadSession = createAction(
  '[Session] Load Session',
  props<{ session_id: string; collection_id: string; collection_name: string }>()
);
export const clearSession = createAction('[Session] Clear Session');
// Conversations
export const setLoading = createAction('[Conversation] Set Loading', props<{ loading: boolean }>());
export const updateUserPrompt = createAction('[Conversation] Update User Prompt', props<{ prompt: string }>());
export const sendNewMessage = createAction('[Conversation] Send New Message', props<{ message: ChatMessage }>());
export const sendMessage = createAction(
  '[Conversation] Send Message',
  props<{
    model_id: string;
    collection_id: string;
    session_id: string | null;
    message: string;
    activeFilters: CollectionAttributes;
  }>()
);
export const sendMessageFailure = createAction('[Conversation] Send Message Failure', props<{ error: string }>());
export const receiveMessage = createAction('[Conversation] Receive Message', props<{ response: AdvisorResponse }>());
export const populateMessages = createAction(
  '[Conversation] Populate Messages',
  props<{ session_id: string; messages: ChatMessage[]; collection_id: string }>()
);
export const startTypingMessage = createAction('[Conversation] Start Typing Message', props<{ fullContent: string }>());
export const appendCharacter = createAction('[Conversation] Append Character', props<{ character: string }>());
export const completeTypingMessage = createAction('[Conversation] Complete Typing Message');
export const loadSourceDocuments = createAction(
  '[Conversation] Load Source Documents',
  props<{ source_documents: SourceDocument[] }>()
);
